// extracted by mini-css-extract-plugin
export default {"main":"_27855e9696","tit":"cb791843fc","maintitle":"_78f9fcdd9d","ylw":"_1d87b21928","white":"_5b5a615ca0","mv_title":"_529dda5b24","mv_nc":"_60e3a84020","mv_in":"ea96744f9d"};